import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-4 relative overflow-hidden" data-id="element-139">
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-blue-900/10 rounded-full blur-[100px] -z-10 pointer-events-none" data-id="element-140"></div>

      <div className="max-w-5xl mx-auto" data-id="element-141">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="md:w-1/2" data-id="element-143">
            <div className="inline-flex items-center justify-center p-3 bg-blue-500/10 rounded-full mb-6" data-id="element-144">
              <Activity className="w-8 h-8 text-blue-500" data-id="element-145" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-146">
              Así Funciona el "Interruptor de Nitrógeno"
              <br data-id="element-147" />
              <span className="text-blue-500 text-2xl md:text-3xl" data-id="element-148">
                (Y Por Qué Es Diferente a Todo lo que Has Probado)
              </span>
            </h2>

            <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-149">
              <p data-id="element-150">
                Imagina que tus arterias son mangueras. Con los años, se vuelven
                rígidas. Pierden elasticidad. El flujo se vuelve lento, débil,
                inconsistente.
              </p>
              <p data-id="element-151">
                Las pastillas intentan aumentar la presión del agua.{' '}
                <span className="text-white font-bold" data-id="element-152">
                  Nosotros reparamos la manguera.
                </span>
              </p>

              <div className="space-y-4 mt-6" data-id="element-153">
                <p className="font-semibold text-white" data-id="element-154">
                  El Protocolo 7 Minutos activa 3 procesos fisiológicos:
                </p>
                <div className="bg-slate-900 p-4 rounded-xl border border-slate-800" data-id="element-155">
                  <h4 className="text-blue-400 font-bold mb-1" data-id="element-156">
                    1️⃣ Biomecánica del Endotelio
                  </h4>
                  <p className="text-sm text-slate-400" data-id="element-157">
                    Ejercicios específicos que "despiertan" la capa interna de
                    tus arterias, haciéndolas más receptivas al flujo sanguíneo.
                  </p>
                </div>
                <div className="bg-slate-900 p-4 rounded-xl border border-slate-800" data-id="element-158">
                  <h4 className="text-blue-400 font-bold mb-1" data-id="element-159">
                    2️⃣ Respiración Diafragmática Estratégica
                  </h4>
                  <p className="text-sm text-slate-400" data-id="element-160">
                    No es meditación. Es una secuencia de oxigenación que fuerza
                    la producción natural de óxido nítrico en 120 segundos.
                  </p>
                </div>
                <div className="bg-slate-900 p-4 rounded-xl border border-slate-800" data-id="element-161">
                  <h4 className="text-blue-400 font-bold mb-1" data-id="element-162">
                    3️⃣ Secuencia de Presión Localizada
                  </h4>
                  <p className="text-sm text-slate-400" data-id="element-163">
                    Movimientos isométricos que dirigen el flujo exactamente
                    donde lo necesitas, sin dispersión.
                  </p>
                </div>
              </div>

              <div className="p-5 bg-slate-900 border-l-4 border-blue-500 rounded-r-xl mt-6" data-id="element-164">
                <p className="font-medium text-slate-200" data-id="element-165">
                  En palabras simples: Es como abrir manualmente una llave de
                  paso que estaba atascada. La sangre no tiene otra opción más
                  que fluir.
                </p>
              </div>

              <div className="pt-4" data-id="element-166">
                <a href="#comprar" className="inline-flex justify-center items-center w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] hover:scale-105 active:scale-95" data-id="element-167">
                  Quiero el Protocolo + Bonos
                </a>
                <p className="text-center sm:text-left text-sm text-slate-500 mt-3" data-id="element-168">
                  Descarga inmediata - $14.99 USD
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="md:w-1/2 w-full max-w-md mx-auto" data-id="element-169">
            <div className="relative" data-id="element-170">
              <div className="absolute inset-0 bg-blue-500/20 blur-2xl rounded-full transform scale-90" data-id="element-171"></div>
              <img src="https://cdn.magicpatterns.com/uploads/4XJAxL1LqPZmUoF4ryzigx/Diseno_sin_titulo.png" alt="Protocolo 7 Minutos Book Cover" width={600} height={800} loading="lazy" decoding="async" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-slate-800" data-id="element-172" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}